// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1neRM","right":"styles_right__3Rg5Y"};